export default "__VITE_ASSET__Cig$GoMv__"